import React, { useEffect } from 'react';
import CookieOutlinedIcon from '@mui/icons-material/CookieOutlined';
import { Button, Box, Typography } from '@mui/material';
import {
  customColorPalette,
  proAccountThemeCoreUI,
} from '@orcha/micro-library-core-ui';
import useTranslation from 'next-translate/useTranslation';
import CookieConsent, { Cookies } from 'react-cookie-consent';
import ReactGA from 'react-ga4';

const CookieButton = ({ children, ...props }) => {
  return (
    <Button
      variant={props.id === 'rcc-decline-button' ? 'outlined' : 'contained'}
      color="inherit"
      sx={[
        {
          margin: proAccountThemeCoreUI.spacing(1),
          background: props.id === 'rcc-decline-button' ? 'inherit' : '#e31c79',
          minWidth: '220px',
        },
        {
          '&:hover': {
            background:
              props.id === 'rcc-decline-button' ? 'inherit' : '#b0155d',
          },
        },
      ]}
      {...props}
    >
      {children}
    </Button>
  );
};

export const CookieBanner = () => {
  const { t } = useTranslation();

  useEffect(() => {
    const cookies = Cookies.get();

    if (cookies?.CookieConsent === 'true') {
      ReactGA.gtag('consent', 'update', {
        ad_storage: 'granted',
        analytics_storage: 'granted',
        functionality_storage: 'granted',
        personalization_storage: 'granted',
        security_storage: 'granted',
      });
    } else if (cookies?.CookieConsent === 'false') {
      ReactGA.gtag('consent', 'update', {
        ad_storage: 'denied',
        analytics_storage: 'denied',
        functionality_storage: 'denied',
        personalization_storage: 'denied',
        security_storage: 'denied',
      });
    }
  }, []);

  return (
    <CookieConsent
      location="none"
      visible="byCookieValue"
      enableDeclineButton
      disableButtonStyles
      style={{
        background: proAccountThemeCoreUI.palette.primary.dark,
        alignItems: 'center',
        textAlign: 'center',
        maxWidth: '550px',
        flexDirection: 'column',
        left: '50%',
        top: '130px',
        borderRadius: proAccountThemeCoreUI.shape.borderRadius * 3,
        padding: proAccountThemeCoreUI.spacing(2.5, 4.25, 3.75),
        transform: 'translate(-50%, 0)',
        boxShadow: '2px 2px 3px rgba(0,0,0,0.26)',
      }}
      contentStyle={{
        margin: 0,
        flex: 'initial',
      }}
      ButtonComponent={CookieButton}
      buttonText={t('cookies.banner.acceptButton')}
      declineButtonText={t('cookies.banner.declineButton')}
      onAccept={() => window.location.reload()}
      onDecline={() => window.location.reload()}
      overlay
    >
      <Box
        style={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'flex-start',
          flexDirection: 'column',
          margin: proAccountThemeCoreUI.spacing(2),
        }}
      >
        <CookieOutlinedIcon
          sx={{
            fontSize: 76,
            color: customColorPalette.blueGrey,
            display: { xs: 'none', sm: 'initial' },
            opacity: '15%',
          }}
          viewBox="2 2 20 20"
        />
        <Box
          style={{
            display: 'flex',
            flexDirection: 'column',
            textAlign: 'left',
            paddingTop: proAccountThemeCoreUI.spacing(2),
            paddingBottom: proAccountThemeCoreUI.spacing(1),
          }}
        >
          <Typography variant="h5" pb={proAccountThemeCoreUI.spacing(1)}>
            {t('cookies.banner.header')}
          </Typography>
          <Typography variant="body1">{t('cookies.banner.body')}</Typography>
        </Box>
      </Box>
    </CookieConsent>
  );
};
